<template>
  <helmi-group-dashboard-card
    :initializing="loadingCharts"
    class="helmi-group-dashboard-cumulative-return"
    title="Tuoton jakautuminen kuukausittain"
    subtitle="(Brutto)"
    fullscreen
    min-height="560px"
    use-theme
  >
    <h-pie-echart :data="echartsData"/>
  </helmi-group-dashboard-card>
</template>

<script>
import { mapState } from 'vuex';

const months = [
  'Tammi',
  'Helmi',
  'Maalis',
  'Huhti',
  'Touko',
  'Kesä',
  'Heinä',
  'Elo',
  'Syys',
  'Loka',
  'Marras',
  'Joulu',
];

export default {
  name: 'GroupDashboardYearlyPie',

  components: {
    'h-pie-echart': () => import('@/components/charts/PieChartEcharts'),
    'helmi-group-dashboard-card': () => import('@/components/groupDashboard/GroupDashboardCard'),
  },

  data: () => ({
    chartData: {
      datasets: [],
    },
    echartsData: [],
    context: null,
    fullscreen: false,
    loaded: false,
  }),

  computed: {
    ...mapState({
      selectedGroupCompanies: 'selectedGroupCompanies',
      chartYear: 'chartYear',
      monthlyProfit: 'monthlyProfit',
      loadingCharts: 'loadingCharts',
    }),
  },

  watch: {
    monthlyProfit: {
      async handler() {
        this.fillCharts();
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    summarize(array, index) {
      let result = 0;
      for (const item of array) { result += item.data[index].profit; }
      return result;
    },

    async fillCharts() {
      const mapped = months.map((month, index) => ({
        name: month,
        value: +(this.summarize(this.monthlyProfit, index).toFixed(2)),
      }));
      this.echartsData = mapped.filter(i => i.value !== 0);
    },
  },

};

</script>
